import { ProjectRenderer } from '../ProjectRenderer';
import { Object3D } from 'three';
import { CreatorAccessory } from '@/types/creator';
import { AccessoryMountingSide } from '@/api/ProductTypeVariationApi';
import { CollidableObject } from './CollidableObject';
import { Accessory } from './Accessory';
import RENDERER_CONFIG from '@/configs/rendererConfig';

export class LedPoint extends CollidableObject {
	static readonly MOUTING_Z_OFFSET = RENDERER_CONFIG.LED_TAPES.MOUTING_Z_OFFSET;

	private creatorAccessory: CreatorAccessory;
	private _mountingSide: CreatorAccessory['mountingSide'] =
		AccessoryMountingSide.BACK;

	constructor(
		renderer: ProjectRenderer,
		creatorAccessory: CreatorAccessory,
		object: Object3D
	) {
		super(
			renderer,
			{
				id: creatorAccessory.refId,
				posY: creatorAccessory.posY,
				linkedObjectId: null,
			},
			object
		);

		this.renderer.project.add(object);

		this.creatorAccessory = creatorAccessory;

		this.mountingSide = creatorAccessory.mountingSide;
	}

	get mountingSide() {
		return this._mountingSide;
	}

	set mountingSide(value: CreatorAccessory['mountingSide']) {
		this._mountingSide = value;

		switch (value) {
			case AccessoryMountingSide.FRONT: {
				this.object.rotation.set(0, 0, 0);
				const posZ =
					this.renderer.handleManager.objectsAvailableSpaceBox3.max.z -
					this.dimensions.z / 2 +
					Accessory.MOUTING_Z_OFFSET;
				this.object.position.setZ(posZ);
				break;
			}
			case AccessoryMountingSide.BACK: {
				this.object.rotation.set(0, Math.PI, 0);
				const posZ =
					this.renderer.handleManager.objectsAvailableSpaceBox3.min.z +
					this.dimensions.z / 2 -
					Accessory.MOUTING_Z_OFFSET;
				this.object.position.setZ(posZ);
				break;
			}
		}

		this.updateBox3();
	}

	override set posY(value: number) {
		this._posY = value;
		this.object.position.setY(value);
		this.updateBox3();
	}

	override get posY() {
		return this._posY;
	}

	override updateBox3() {
		this.object.updateMatrixWorld();
		this.collisionBox.setFromObject(this.object, true);
	}

	clone() {
		return new LedPoint(
			this.renderer,
			this.creatorAccessory,
			this.object.clone()
		);
	}
}
